import { Grid } from '@mui/material';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { FormInput } from '~/components/FormComponents/FormInput';
import { AddressInfo } from '~/modules/identification/components/FormComponents/AddressInfo';
import { DocumentInfo } from '~/modules/identification/components/FormComponents/DocumentInfo';

import FormContainer from '~/modules/identification/components/FormComponents/FormContainer';
import IdentificationNumberBlock from '~/modules/identification/components/FormComponents/IdentificationNumberBlock';
import PersonalInfoBlock from '~/modules/identification/components/FormComponents/PersonalInfoBlock';
import { useAddressQuery } from '~/queries/useAddressQuery';
import { usePositionsQuery } from '~/queries/usePositionsQuery';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';

export const ManagerInfo = () => {
  const { positionOptions } = usePositionsQuery();
  const { nonAgressionCountryOptions, countryOptions } = useAddressQuery();

  return (
    <FormContainer>
      <PersonalInfoBlock />
      <IdentificationNumberBlock />
      <FormGridItem>
        <FormAutocomplete
          name={'citizenshipCountry'}
          options={countryOptions}
          inputProps={{
            placeholder: 'Оберіть країну громадянства',
          }}
          label="Країна громадянства"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          name={'residenceCountry'}
          options={nonAgressionCountryOptions}
          placeholder="Оберіть країну резидентства"
          inputProps={{
            placeholder: 'Оберіть країну резидентства',
          }}
          label="Країна резидентства"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          name={'birthCountry'}
          options={countryOptions}
          inputProps={{
            placeholder: 'Оберіть країну народження',
          }}
          label="Країна народження"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={'birthPlace'}
          label="Місце народження"
          placeholder="Введіть місце народження"
          fullWidth
          inputProps={{
            maxLength: 120,
          }}
        />
      </FormGridItem>
      <DocumentInfo
        citizenshipCountryPath="citizenshipCountry"
        residenceCountryPath="residenceCountry"
      />
      <AddressInfo />
      <FormGridItem sx={{ alignContent: 'flex-end' }}>
        <FormAutocomplete
          options={positionOptions}
          name="position"
          inputProps={{
            placeholder: 'Оберіть посаду',
          }}
          label="Посада"
          shouldSaveLabel
        />
      </FormGridItem>
      <Grid size={12} sx={{ alignContent: 'flex-end' }}>
        <FormYesNoQuestion
          name="isAccountHolder"
          question="Чи являєтесь ви розпорядником рахунку?"
        />
      </Grid>
    </FormContainer>
  );
};
